'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M0 1024h64l192-320c0 0 0 0 192 0s313-493 576-704c-561 0-896 640-1024 1024zM392 576h-72c0 0 177-320 448-448 0 0-243 215-376 448z' })
    ));
};